import { STORAGE_ITEMS } from "constants/Storage";

// Set to Local storage

export const setTokenToLocalStorage = (token: string | null | undefined): void =>
  localStorage.setItem(STORAGE_ITEMS.TOKEN, token || "");

export const setBUToLocalStorage = (businessUnitId: string): void =>
  localStorage.setItem(STORAGE_ITEMS.SELECTED_BU, businessUnitId);

export const setBUTypeToLocalStorage = (businessUnitType: string): void =>
  localStorage.setItem(STORAGE_ITEMS.SELECTED_BU_TYPE, businessUnitType);

export const setAppVersionToLocalStorage = (version: string): void =>
  localStorage.setItem(STORAGE_ITEMS.PERSIST_VERSION, version);

export const setFeaturesListToLocalStorage = (featuresList: string): void =>
  localStorage.setItem(STORAGE_ITEMS.FEATURES_LIST, featuresList);

export const setTaskIdToLocalStorage = (taskId: string): void => localStorage.setItem(STORAGE_ITEMS.TASK_ID, taskId);

export const setLocationsCountToLocalStorage = (locationsCount: string): void => {
  localStorage.setItem(STORAGE_ITEMS.LOCATIONS_COUNT, locationsCount);
};

// Get from Local storage

export const getTokenFromLocalStorage = (): string | null => localStorage.getItem(STORAGE_ITEMS.TOKEN);

export const getBUFromLocalStorage = (): number => Number(localStorage.getItem(STORAGE_ITEMS.SELECTED_BU));

export const getBUTypeFromLocalStorage = (): string | null => localStorage.getItem(STORAGE_ITEMS.SELECTED_BU_TYPE);

export const getAppVersionFromLocalStorage = (): string | null => localStorage.getItem(STORAGE_ITEMS.PERSIST_VERSION);

export const getFeaturesListFromLocalStorage = (): string | null => localStorage.getItem(STORAGE_ITEMS.FEATURES_LIST);

export const getTaskIdFromLocalStorage = (): string | null => localStorage.getItem(STORAGE_ITEMS.TASK_ID);

export const getLocationsCountToLocalStorage = (): string | null => localStorage.getItem(STORAGE_ITEMS.LOCATIONS_COUNT);

// Remove from Local storage

export const removeTaskIdFromLocalStorage = (): void => localStorage.removeItem(STORAGE_ITEMS.TASK_ID);

// Clear Local storage

export const clearLocalStorage = (): void => localStorage.clear();
